<template>
    <div class="borrow-error">
        <div class="error-msg">
            <img v-if="errorCode === 50101" src="~@/assets/error_icons/station-not-set-up.webp" alt="station not found">
            <img v-else-if="errorCode === 50102" src="~@/assets/error_icons/station-not-set-up.webp" alt="station not set up">
            <img v-else-if="errorCode === 50106" src="~@/assets/error_icons/station-offline.webp" alt="station offline">
            <img v-else-if="errorCode === 50107" src="~@/assets/error_icons/station-not-set-up.webp" alt="station busy">
            <img v-else-if="errorCode === 50108" src="~@/assets/error_icons/power-banks-unavailable.webp" alt="power banks unavailable">
            <img v-else-if="errorCode === 50110" src="~@/assets/error_icons/no-power-banks-available.webp" alt="no power banks available">
            <img v-else src="~@/assets/error_icons/server-error.webp" alt="server error">
            <h1>{{ errorTitle }}</h1>
            <h2>{{ errorMsg }}</h2>
        </div>
    </div>
</template>

<script>
export default {
    name: "Error",
    data() {
        return {
            errorTitle: '',
            errorCode: false,
            errorMsg: ''
        }
    },
    created() {
        this.errorCode = Number(this.$route.query.code) || this.$store.getters['appConfig/error_flag'];
        console.log(this.errorCode,'this.errorCode');

        // 根据不同的 errorCode 设置标题
        switch (this.errorCode) {
            case 50101:
                this.errorTitle = this.$t('m.stationNotFoundTitle');
                this.errorMsg = this.$t('m.stationNotFound');
                break;
            case 50102:
                this.errorTitle = this.$t('m.stationNotSetUpTitle');
                this.errorMsg = this.$t('m.stationNotSetUp');
                break;
            case 50106:
                this.errorTitle = this.$t('m.stationOfflineTitle');
                this.errorMsg = this.$t('m.stationOffline');
                break;
            case 50107:
                this.errorTitle = this.$t('m.stationBusyTitle');
                this.errorMsg = this.$t('m.stationBusy');
                break;
            case 50108:
                this.errorTitle = this.$t('m.powerBanksUnavailableTitle');
                this.errorMsg = this.$t('m.powerBanksUnavailable');
                break;
            case 50110:
                this.errorTitle = this.$t('m.noPowerBanksAvailableTitle');
                this.errorMsg = this.$t('m.noPowerBanksAvailable');
                break;
            default:
                this.errorTitle = this.$t('m.serverErrorTitle');
                this.errorMsg = this.$t('m.serverError');
        }
    }
};
</script>

<style lang="scss">
.borrow-error {
    background: #fff ;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;

    .error-msg {
        position: absolute;
        top: 43%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 283px;

        img {
            height: 35px;
            width: auto;
            max-width: 40px;
        }

        h1 {
            width: 100%;
            text-align: center;
            margin: 0;
            color: #202124;
            font-family: "SF Pro Display";
            font-size: 20px;
            font-weight: 700;
            line-height: 140%;
            margin-top: 10px;
            margin-bottom: 5px;
        }

        h2 {
            width: 100%;
            text-align: center;
            margin: 0;
            color: #333;
            text-align: center;
            font-family: "SF Pro";
            font-size: 14px;
            line-height: 144%;
            font-weight: 400;
        }
    }
}
</style>
